import React from 'react';
import styles from './index.module.scss';

interface StarRatingProps {
  count: number;
  total?: number;
}

const StarRating: React.FC<StarRatingProps> = ({ count, total = 5 }) => {
  return (
    <div className={styles.starRating}>
      {[...Array(total)].map((_, index) => (
        <span key={index} className={`${styles.star} ${index < count ? styles.filled : ''}`}>
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;